module.exports = __webpack_public_path__ + "img/local.1.2fd7568b.png";